import { render, staticRenderFns } from "./SeoComponent.vue?vue&type=template&id=016dc35a&"
import script from "./SeoComponent.vue?vue&type=script&lang=js&"
export * from "./SeoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports